import { Stack } from "@fluentui/react";
import { animated, useSpring } from "@react-spring/web";
import elypseImg from "../../assets/img/MIA_circulo-azul.png";
import styles from "./Answer.module.css";
import { AnswerIcon } from "./AnswerIcon";

export const AnswerLoading = () => {
    const animatedStyles = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 }
    });

    return (
        <animated.div className="w-100" style={{ ...animatedStyles }}>
            <Stack className={styles.answerContainer} verticalAlign="space-between">
                <Stack.Item grow>
                    <div className={styles.responseGenerate}>
                        <img src={elypseImg} alt="logo-elypse" />
                        <div className={styles.dots}>
                            <span>Generando respuesta</span>
                            <span className={styles.loadingdots} />
                        </div>
                    </div>
                </Stack.Item>
            </Stack>
        </animated.div>
    );
};
